// src/services/LevelService.js
import http from './Http'; // Usa el cliente Axios configurado

const listarNiveles = () => {
  return http.get('/niveles/');
};

const listarGradosPorNivel = (nivelId) => {
  return http.get(`/niveles/${nivelId}/grados`);
};

const NivelService = {
  listarNiveles,
  listarGradosPorNivel
};

export default NivelService;